import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"



// Authentication related pages
import Login from "../pages/Authentication/Login"
import AdminLogin from "../pages/Authentication/AdminLogin";
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"


// Dashboard
import Dashboard from "../pages/Dashboard/index"


//Course
import CreateCourse from "pages/Course/CreateCourse";
import AllCourses from "pages/Course/AllCourses";

// Difficulty 
import CreateDifficulty from "pages/Difficulty/CreateDifficulty"
import AllDifficulty from "pages/Difficulty/AllDifficulty"


import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";
import CreateUser from "pages/User/CreateUser"
import AllUsers from "pages/User/AllUsers"

import AllStudents from "pages/student/AllStudents"
import AllUserType from "pages/User/AllUserType"
import CreateUserType from "pages/User/CreateUserType"
import CreateCategory from "pages/Category/CreateCategory"
import AllCategories from "pages/Category/AllCategories"
import CreateSubCategory from "pages/SubCategory/CreateSubCategory"
import AllSubCategories from "pages/SubCategory/AllSubCategories"
import EditCourse from "pages/Course/EditCourse"
import CreateGroup from "pages/Group/CreateGroup"
import AllGroup from "pages/Group/AllGroup"
import CreateStudent from "pages/student/CreateStudent"
import CreateSingleStudent from "pages/student/CreateSingleStudent"
import StudentDetails from "pages/student/StudentDetails"
import CreateMultipleStudent from "pages/student/CreateMultipleStudent"
import BatchDetails from "pages/Group/BatchDetails"
import MyBatches from "pages/Group/MyBatches"
import CourseView from "pages/Course/CourseView"
import Refer from "pages/Referral/Refer"
import AllReferrals from "pages/Referral/AllReferrals"
import ProctorDashboard from "pages/Group/ProctorDashboard"
import StudentFullView from "pages/Group/StudentFullView"
import CreateScormCourse from "pages/Course/CreateScormCourse"
import AllScormCourses from "pages/Course/AllScormCourses"
import ScormPlayer from "pages/Course/components/ScormPlayer"
import TrainingCalendar from "pages/TrainingCalendar/TrainingCalendar"
import ResetPassowrd from "pages/Authentication/ResetPassowrd"
import BronzeAssessment from "pages/Group/Components/BronzeAssessment"
import DriverMarkingSystem from "pages/Group/Components/DriverMarkingSystem"
import ScormPlayerRoute from 'pages/Course/components/ScormPlayerRoute';
import StudentTrainingHistory from "pages/StudentTrainingHistory/StudentTrainingHistory";

// src/helpers/url_helper.js - Add these endpoints


const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  { path: "/profile", component: <UserProfile /> },




  // USER MANAGEMENT
  { path: "/create-new-user", component: <CreateUser /> },
  { path: "/all-users", component: <AllUsers /> },
  { path: "/all-userTypes", component: <AllUserType /> },
  { path: "/create-new-userType", component: <CreateUserType /> },


  // CONTENT MANAGEMENT
  { path: "/create-new-course", component: <CreateCourse /> },
  { path: "/create-new-scorm-course", component: <CreateScormCourse /> },
  { path: "/all-courses", component: <AllCourses /> },
  { path: "/all-scorm-courses", component: <AllScormCourses /> },
  { path: "/edit-course/:id", component: <EditCourse /> },
  { path: "/course-view/:id", component: <CourseView /> },
  { path: "/scrom-course-view", component: <ScormPlayer /> },

  { path: "/scorm-player/:courseId", component: <ScormPlayer/> },

 

  // Refer & Earn
  { path: "/training-calendar", component: <TrainingCalendar /> },

  // Refer & Earn
  { path: "/refer", component: <Refer /> },
  { path: "/all-referrals", component: <AllReferrals /> },


  // Category
  { path: "/create-category", component: <CreateCategory /> },
  { path: "/all-categories", component: <AllCategories /> },

  // Sub Category
  { path: "/create-sub-category", component: <CreateSubCategory /> },
  { path: "/all-sub-categories", component: <AllSubCategories /> },

  // level
  { path: "/create-level", component: <CreateDifficulty /> },
  { path: "/all-level", component: <AllDifficulty /> },

  // group
  { path: "/create-batch", component: <CreateGroup /> },
  { path: "/all-batches", component: <AllGroup /> },
  { path: "/my-batches", component: <MyBatches /> },
  { path: "/batch/:id", component: <BatchDetails /> },
  { path: "/proctor-dashboard/:examId", component: <ProctorDashboard /> },
  { path: "/proctor-dashboard/:examId/student/:studentId", component: <StudentFullView /> },
  

  // technical assessment
   { path: "/batch-details/:id/bronze", component: <BronzeAssessment /> },
    { path: "/bronze", component: <BronzeAssessment /> },


   // Driver Marking System

   { path: "/batch-details/:id/driver", component: <DriverMarkingSystem /> },
   { path: "/driver", component: <DriverMarkingSystem /> },





  // this route should be at the end of all other routes

  // student
  { path: "/create-student", component: <CreateStudent /> },
  { path: "/all-students", component: <AllStudents /> },
  { path: "/create-single-student", component: <CreateSingleStudent /> },
  { path: "/create-multiple-student", component: <CreateMultipleStudent /> },
  { path: "/student/:id", component: <StudentDetails /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },

//student training history url for tml

  { path: "/student-training-history", component: <StudentTrainingHistory /> },

  
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },

  { path: "/login", component: <Login /> },
  { path: "/adminlogin", component: <AdminLogin /> },
  { path: "/forgot-password", component: <ForgetPwd /> },

  { path: "/reset-password", component: <ResetPassowrd /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // { path: "/pages-register", component: <Register1 /> },
  // { path: "/page-recoverpw", component: <Recoverpw /> },
  // { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }